import { ICON_VARIANT_TYPE, Icons } from 'pages/Workshop/Forms/Icons';
import styles from './styles.module.scss';
import { FormLink } from '../FormLink/FormLink';
import { Fragment, useState } from 'react';
import classNames from 'classnames';

export const FormLinkWrapper = (props) => {
  const [showEmptyView, setShowEmptyView] = useState(true);

  const { formDetails } = props;

  const toggleEmptyView = (value) => {
    setShowEmptyView(value);
  };

  if (!formDetails) return null;

  const { isOwner, transactionId, client } = formDetails;

  const isFormCreator = isOwner;
  const showLinkText = isFormCreator || transactionId || client;
  const showLinkPlaceholder = showEmptyView && !transactionId && !client;

  return (
    <div className={styles.formLinkWrapper}>
      {showLinkText && <h1 className={styles.heading}>This form is linked to:</h1>}

      <div className={classNames({ [styles.formLinkContainer]: showLinkPlaceholder })}>
        {showLinkPlaceholder && (
          <div className={styles.emptyLinkView}>
            <Fragment>
              <Icons variant={ICON_VARIANT_TYPE.FORM_LINK} />
              <div className={styles.noLinkText}>
                This form is not linked to any transactions or clients.
              </div>
            </Fragment>
          </div>
        )}

        <FormLink {...props} toggleEmptyView={toggleEmptyView} />
      </div>
    </div>
  );
};
